import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Suspense, useEffect } from "react";
import "./App.scss";
import { Privateroutes, PublicRoutes } from "./routes";
import SellerHome from "./pages/sellerHome/SellerHome";
import Login from "./pages/login/Login";


import ProtectedRoute from "./routes/ProtectRoute";
import Scrollto from "./component/scrollto/Scrollto";
import { ToastContainer } from "react-toastify";

function App() {
  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", function () {
      window.history.pushState(null, "", window.location.href);
    });
  }, []);

  useEffect(() => {
    const today = new Date().toDateString();
    const lastClear = localStorage.getItem("lastClear");

    if (!lastClear) {
      // first time → just set lastClear, don’t clear
      localStorage.setItem("lastClear", today);
    } else if (lastClear !== today) {
      // new day → clear everything
      localStorage.clear();
      localStorage.setItem("lastClear", today);
    }
  }, []);



  return (
    <div className="App">
      <Suspense fallback={<div>Loading...</div>}>
        <ToastContainer
          position="top-right"
          style={{ zIndex: 1000 }}
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        {/* <PrivateRoute>
       
        </PrivateRoute> */}
        <Scrollto />
        <Routes>
          {/* Public Routes */}

          <Route path="/" element={<SellerHome />} />
          {
            PublicRoutes.map((item, index) => (
              <Route path={item.path} key={index} element={<item.component />} />
            ))
          }

          <Route path="/login" element={<Login />} />

          {/* Private Routes */}

          {
            Privateroutes.map((item, index) => (
              <Route path={item.path} key={index} element={<ProtectedRoute> <item.component /> </ProtectedRoute>} />
            ))
          }


          {/* Catch-all 404 */}
          <Route path="/404" element={<h1>404 Not Found</h1>} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>

      </Suspense>
    </div>
  );
}

export default App;
